import { useIsMobile } from 'shared/hooks/use-is-mobile'
import { useDashboard } from '../hooks/useDashboard'
import { useHourlyEventCounts } from '../hooks/useHourlyEventCounts'
import { useVehicleFlow } from '../hooks/useVehicleFlow'
import './dashboard-views.scss'
import CameraCaptureCounter from './dashboard-camera-counter/dashboard-camera-counter'
import StatusDot from './dashboard-capture-status/status-dot'
import DashboardViewMobile from './dashboard-view-mobile'
import NotificationGrid from './dashboard-notifications/dashboard-notification-grid/dashboard-notification-grid'
import VehicleTypeCounter from './dashboard-vehicle-type-counter/dashboard-vehicle-type-counter'
import DashboardHourlyChart from './dashboard-hourly-chart/dashboard-hourly-chart'
import DashboardVehicleFlow from './dashboard-vehicle-flow/dashboard-vehicle-flow'
const DashboardView = () => {
  const {
    cameraPerformance,
    yesterdayCameraPerformance,
    eventHistory,
    vehicleCount,
    captureOnline,
    signalRConnected,
  } = useDashboard()
  const { hourlyCounts } = useHourlyEventCounts()
  const { flow } = useVehicleFlow()

  const isMobile = useIsMobile()

  return (
    <div
      className={`dashboard-container${isMobile ? ' dashboard-container--mobile' : ''}`}
    >
      <div className='dashboard-status-row flex justify-content-end align-items-center gap-2 mb-3'>
        <StatusDot
          online={signalRConnected}
          label={
            signalRConnected
              ? 'Conexão em tempo real ativa'
              : 'Conexão em tempo real indisponível'
          }
        />
        <StatusDot
          online={captureOnline}
          label={
            captureOnline
              ? 'Captura on-premise ativa'
              : 'Captura on-premise offline'
          }
        />
      </div>
      {isMobile ? (
        <DashboardViewMobile
          cameraPerformance={cameraPerformance}
          yesterdayCameraPerformance={yesterdayCameraPerformance}
          vehicleCount={vehicleCount}
          eventHistory={eventHistory}
        />
      ) : (
        <div className='grid'>
          <div className='col-12 lg:col-12 xl:col-8'>
            <CameraCaptureCounter cameraPerformance={cameraPerformance} />
            <VehicleTypeCounter vehicleCounts={vehicleCount} />
            <DashboardVehicleFlow flow={flow} />
            <DashboardHourlyChart hourlyCounts={hourlyCounts} />
          </div>
          <div className='col-12 lg:col-12 xl:col-4'>
            <NotificationGrid eventHistory={eventHistory} />
          </div>
        </div>
      )}
    </div>
  )
}

export default DashboardView
